import Backbone from 'backbone';
import moment from 'moment';

import allUsersStore from 'zoomforth_zf/appglobals/all-users.js';

import { defaultDatetimeFormat } from 'zoomforth_zfutils/datetime_formatting.js';

var Form = Backbone.Model.extend({
    
  urlRoot: '/api/forms',
  
  getAsOldStyleAsset: function(){
    var oldStyleAsset = {};
    oldStyleAsset.data = {
      id: this.get('id'),
      assetType: 'form'
    };
    return oldStyleAsset;
  },
  
  hasResponses: function(){
    return ( parseInt(this.get('response_count')) > 0 );
  },
  
  getFields: function(){
    return this.get('fields');
  },

  isActive: function() {
    return this.get('active') == 1;
  },

  isArchived: function() {
    return this.get('is_archived') == 1;
  },

  getArchivedMetadata: function() {
    if (!this.isArchived()) {
      return null;
    } else if (!this.get('archived_metadata')) {
      return null;
    }

    const metadata = this.get('archived_metadata');

    return {
      archivedOn: defaultDatetimeFormat(moment(metadata.archived_on)),
      archivedBy: allUsersStore.get().get(metadata.archived_by_user_id) || null
    };
  },
  
  _baseReportingUrl: function(){
    return '/form_reporting/' + this.get('id');
  },
  
  getCSVUrl: function(){
    return  this._baseReportingUrl() + '/basic.csv';
  },
  
  getJSONUrl: function(){
    return this._baseReportingUrl() + '/basic.json';
  }

});

export default Form;

export const FIELD_TYPE_SHORT_ANSWER = 'text';
export const FIELD_TYPE_LONG_ANSWER = 'textarea';
export const FIELD_TYPE_SINGLE_ANSWER = 'radio';
export const FIELD_TYPE_MULTI_ANSWER = 'checkbox';